
import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Smartphone, Monitor, QrCode, Play, Pause, Volume2, VolumeX, Maximize2, Eye, Download, Share2 } from 'lucide-react';

const LiptonDetail= () => {
  const [selectedAdId, setSelectedAdId] = useState(2);
  const [viewMode, setViewMode] = useState('desktop');
  const [isPlaying, setIsPlaying] = useState(true);
  const [isMuted, setIsMuted] = useState(true);
  const [showPreview, setShowPreview] = useState(false);
  const [videoError, setVideoError] = useState(false);

  const adFormats = [
    {
      id: 1,
      name: '2025_05_Mars_FP_RM_Sta',
      dimension: '320x480',
      type: 'Video Banner',
      creativeId: '1552639',
      gradient: 'from-rose-400 via-pink-500 to-purple-600',
      video: 'https://dsp.eskimi.com/files/upload/rm/upload/6728f827e708b/Standard_v8_Prod_320x480_FP/assets/vid.mp4'
    },
    {
      id: 2,
      name: '2025_05_Mars_FP_RM_Sta',
      dimension: '300x250',
      type: 'Video Banner',
      creativeId: '1552640',
      gradient: 'from-cyan-400 via-blue-500 to-indigo-600',
      video: 'https://dsp.eskimi.com/files/upload/rm/upload/6728f8262b049/Standard_v8_Prod_300x250_FP/assets/vid.mp4'
    },
    {
      id: 3,
      name: '2025_05_Mars_FP_RM_Sta',
      dimension: '320x480',
      type: 'Video Banner',
      creativeId: '1552641',
      gradient: 'from-violet-500 via-purple-600 to-pink-600',
      video: 'https://dsp.eskimi.com/files/upload/rm/upload/6728f827e708b/Standard_v8_Prod_320x480_FP/assets/vid.mp4'
    },
    // {
    //     id: 4,
    //     name: '2025_05_Mars_FP_RM_Sta',
    //     dimension: '320x480',
    //     type: 'Video Banner',
    //     creativeId: '1552641',
    //     gradient: 'from-violet-500 via-purple-600 to-pink-600',
    //     video: 'https://dsp.eskimi.com/files/upload/rm/upload/6733759050c29/Standard_320x480_v7_KZ/assets/vid.mp4'
    //   },
    //   {
    //     id: 5,
    //     name: '2025_05_Mars_FP_RM_Sta',
    //     dimension: '300x600',
    //     type: 'Video Banner',
    //     creativeId: '1552641',
    //     gradient: 'from-violet-500 via-purple-600 to-pink-600',
    //     video: 'https://dsp.eskimi.com/files/upload/rm/upload/6728f82715210/Standard_v8_Prod_300x600_FP/assets/vid.mp4'
    //   },
    //   {
    //     id: 5,
    //     name: '2025_05_Mars_FP_RM_Sta',
    //     dimension: '300x600',
    //     type: 'Video Banner',
    //     creativeId: '1552641',
    //     gradient: 'from-violet-500 via-purple-600 to-pink-600',
    //     video: 'https://dsp.eskimi.com/files/upload/rm/upload/6728f82715210/Standard_v8_Prod_300x600_FP/assets/vid.mp4'
    //   },
 
  ];
  
  const currentAd = adFormats.find(ad => ad.id === selectedAdId) || adFormats[1];

  useEffect(() => {
    setShowPreview(true);
    setVideoError(false);
  }, [selectedAdId]);

  const selectAd = (adId) => {
    setShowPreview(false);
    setTimeout(() => {
      setSelectedAdId(adId);
    }, 150);
  };

  const nextAd = () => {
    const currentIndex = adFormats.findIndex(ad => ad.id === selectedAdId);
    const nextIndex = currentIndex === adFormats.length - 1 ? 0 : currentIndex + 1;
    selectAd(adFormats[nextIndex].id);
  };

  const prevAd = () => {
    const currentIndex = adFormats.findIndex(ad => ad.id === selectedAdId);
    const prevIndex = currentIndex === 0 ? adFormats.length - 1 : currentIndex - 1;
    selectAd(adFormats[prevIndex].id);
  };

  const AdContent = ({ className = "" }) => {
    const handleVideoError = () => {
      setVideoError(true);
    };

    const renderFallbackContent = () => (
      <div className={`bg-gradient-to-br ${currentAd.gradient} flex items-center justify-center text-white text-center h-full w-full`}>
        <div className="animate-pulse">
          <div className="text-3xl mb-3">✈️</div>
          <div className="text-xl font-bold mb-2">Turkish Airlines</div>
          <div className="text-sm opacity-80">Widen Your World</div>
        </div>
      </div>
    );

    return (
      <div className={`relative group ${className}`}>
        {currentAd.dimension === '300x250' && (
          <div className="w-[300px] h-[250px] rounded-2xl overflow-hidden shadow-2xl relative">
            {!videoError ? (
              <video
                // autoPlay={isPlaying}
                // muted={isMuted}
                autoPlay
                muted
                loop
                playsInline
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                onError={handleVideoError}
              >
                <source src={currentAd.video} type="video/mp4" />
              </video>
            ) : (
              renderFallbackContent()
            )}
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
              <div className="flex space-x-2">
                <button 
                  onClick={() => setIsPlaying(!isPlaying)}
                  className="bg-white/90 hover:bg-white text-gray-800 p-2 rounded-full shadow-lg transition-all transform hover:scale-110"
                >
                  {isPlaying ? <Pause size={16} /> : <Play size={16} />}
                </button>
                <button 
                  onClick={() => setIsMuted(!isMuted)}
                  className="bg-white/90 hover:bg-white text-gray-800 p-2 rounded-full shadow-lg transition-all transform hover:scale-110"
                >
                  {isMuted ? <VolumeX size={16} /> : <Volume2 size={16} />}
                </button>
              </div>
            </div>
          </div>
        )}
        
        {currentAd.dimension === '300x600' && (
          <div className="w-[300px] h-[600px] rounded-2xl overflow-hidden shadow-2xl relative">
            {!videoError ? (
              <video
              autoPlay
              muted
              loop
              playsInline
                
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                onError={handleVideoError}
              >
                <source src={currentAd.video} type="video/mp4" />
              </video>
            ) : (
              renderFallbackContent()
            )}
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
              <div className="flex space-x-2">
                <button 
                  onClick={() => setIsPlaying(!isPlaying)}
                  className="bg-white/90 hover:bg-white text-gray-800 p-2 rounded-full shadow-lg transition-all transform hover:scale-110"
                >
                  {isPlaying ? <Pause size={18} /> : <Play size={18} />}
                </button>
                <button 
                  onClick={() => setIsMuted(!isMuted)}
                  className="bg-white/90 hover:bg-white text-gray-800 p-2 rounded-full shadow-lg transition-all transform hover:scale-110"
                >
                  {isMuted ? <VolumeX size={18} /> : <Volume2 size={18} />}
                </button>
              </div>
            </div>
          </div>
        )}
        
        {currentAd.dimension === '320x480' && (
          <div className="w-[320px] h-[480px] rounded-2xl overflow-hidden shadow-2xl relative">
            {!videoError ? (
              <video
              autoPlay
              muted
              loop
              playsInline
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                onError={handleVideoError}
              >
                <source src={currentAd.video} type="video/mp4" />
              </video>
            ) : (
              renderFallbackContent()
            )}
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
              <div className="flex space-x-2">
                <button 
                  onClick={() => setIsPlaying(!isPlaying)}
                  className="bg-white/90 hover:bg-white text-gray-800 p-2 rounded-full shadow-lg transition-all transform hover:scale-110"
                >
                  {isPlaying ? <Pause size={18} /> : <Play size={18} />}
                </button>
                <button 
                  onClick={() => setIsMuted(!isMuted)}
                  className="bg-white/90 hover:bg-white text-gray-800 p-2 rounded-full shadow-lg transition-all transform hover:scale-110"
                >
                  {isMuted ? <VolumeX size={18} /> : <Volume2 size={18} />}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-50/50 overflow-x-hidden mt-14">
      {/* Animated Background Elements */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-purple-300/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-blue-300/20 rounded-full blur-3xl animate-pulse" style={{animationDelay: '2s'}}></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-72 h-72 bg-pink-300/10 rounded-full blur-3xl animate-pulse" style={{animationDelay: '4s'}}></div>
      </div>

      <div className="relative z-10 flex min-h-screen max-w-full overflow-x-hidden">
        {/* Left Sidebar */}
        <div className="w-80 bg-white/80 backdrop-blur-xl border-r border-white/20 shadow-xl hidden lg:block flex-shrink-0">
          <div className="p-6">
            {/* Header */}
            <div className="mb-8">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-3 h-3 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full animate-pulse"></div>
                <h2 className="text-xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">Creative Suite</h2>
              </div>
              <p className="text-sm text-gray-500">Turkish Airlines Campaign</p>
            </div>

            {/* Ad Formats */}
            <div className="space-y-3">
              {adFormats.map((ad, index) => (
                <div 
                  key={ad.id}
                  onClick={() => selectAd(ad.id)}
                  className={`group p-4 rounded-2xl cursor-pointer transition-all duration-300 transform hover:scale-[1.02] ${
                    ad.id === selectedAdId
                      ? 'bg-gradient-to-r from-blue-500/20 to-purple-500/20 border-2 border-blue-300/50 shadow-lg' 
                      : 'bg-white/60 border border-gray-200/50 hover:bg-white/80 hover:border-gray-300/50'
                  }`}
                  style={{animationDelay: `${index * 100}ms`}}
                >
                  <div className="flex items-center space-x-4">
                    {/* Thumbnail */}
                    <div className="relative flex-shrink-0">
                      {ad.dimension === '300x250' && (
                        <div className={`w-16 h-12 bg-gradient-to-br ${ad.gradient} rounded-lg shadow-md flex items-center justify-center group-hover:shadow-lg transition-shadow`}>
                          <Play size={12} className="text-white" />
                        </div>
                      )}
                      {ad.dimension === '300x600' && (
                        <div className={`w-10 h-20 bg-gradient-to-b ${ad.gradient} rounded-lg shadow-md flex items-center justify-center group-hover:shadow-lg transition-shadow`}>
                          <Play size={10} className="text-white" />
                        </div>
                      )}
                      {ad.dimension === '320x480' && (
                        <div className={`w-12 h-16 bg-gradient-to-br ${ad.gradient} rounded-lg shadow-md flex items-center justify-center group-hover:shadow-lg transition-shadow`}>
                          <Play size={10} className="text-white" />
                        </div>
                      )}
                      {ad.id === selectedAdId && (
                        <div className="absolute -top-1 -right-1 w-4 h-4 bg-green-500 border-2 border-white rounded-full animate-bounce"></div>
                      )}
                    </div>
                    
                    {/* Details */}
                    <div className="flex-1 min-w-0">
                      <div className="text-sm font-semibold text-gray-800 truncate mb-1">
                        {ad.name}
                      </div>
                      <div className="text-xs text-blue-600 font-medium">
                        {ad.dimension}
                      </div>
                      <div className="text-xs text-gray-500">
                        {ad.type}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Action Buttons */}
            <div className="mt-8 pt-6 border-t border-gray-200/50">
              <button className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-3 px-4 rounded-xl font-medium hover:from-blue-700 hover:to-purple-700 transition-all duration-200 transform hover:scale-[1.02] shadow-lg">
                Export All Creatives
              </button>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="flex-1 flex flex-col min-w-0">
          {/* Header */}
          <header className="bg-white/80 backdrop-blur-xl border-b border-white/20 shadow-sm">
            <div className="px-4 sm:px-6 py-4">
              <div className="flex items-center justify-between flex-wrap gap-4">
                <div className="flex items-center space-x-4 min-w-0">
                  <h1 className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent truncate">
                    Ad Preview Studio
                  </h1>
                  <div className="flex items-center space-x-2 text-sm text-gray-500">
                    <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                    <span className="hidden sm:inline">Live Preview</span>
                  </div>
                </div>
                
                {/* View Mode Toggle */}
                <div className="flex items-center space-x-2 sm:space-x-4 flex-shrink-0">
                  <div className="bg-gray-100/80 backdrop-blur-sm rounded-xl p-1 flex">
                    <button
                      onClick={() => setViewMode('mobile')}
                      className={`flex items-center space-x-1 sm:space-x-2 px-2 sm:px-4 py-2 rounded-lg text-xs sm:text-sm font-medium transition-all duration-200 ${
                        viewMode === 'mobile' 
                          ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-md transform scale-105' 
                          : 'text-gray-600 hover:bg-white/60'
                      }`}
                    >
                      <Smartphone size={16} />
                      <span className="hidden sm:inline">Mobile</span>
                    </button>
                    <button
                      onClick={() => setViewMode('desktop')}
                      className={`flex items-center space-x-1 sm:space-x-2 px-2 sm:px-4 py-2 rounded-lg text-xs sm:text-sm font-medium transition-all duration-200 ${
                        viewMode === 'desktop' 
                          ? 'bg-gradient-to-r from-gray-800 to-gray-600 text-white shadow-md transform scale-105' 
                          : 'text-gray-600 hover:bg-white/60'
                      }`}
                    >
                      <Monitor size={16} />
                      <span className="hidden sm:inline">Desktop</span>
                    </button>
                  </div>

                  {/* Action Buttons */}
                  <div className="flex items-center space-x-2">
                    <button className="p-2 text-gray-600 hover:text-gray-800 hover:bg-white/60 rounded-lg transition-all">
                      <Eye size={18} />
                    </button>
                    <button className="p-2 text-gray-600 hover:text-gray-800 hover:bg-white/60 rounded-lg transition-all">
                      <Download size={18} />
                    </button>
                    <button className="p-2 text-gray-600 hover:text-gray-800 hover:bg-white/60 rounded-lg transition-all">
                      <Share2 size={18} />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </header>

          {/* Content Area */}
          <div className="flex-1 flex overflow-hidden">
            {/* Preview Area */}
            <div className="flex-1 p-4 lg:p-8 overflow-hidden">
              {/* Navigation */}
              <div className="flex items-center justify-center space-x-4 lg:space-x-6 mb-6 lg:mb-8">
                <button 
                  onClick={prevAd}
                  className="group flex items-center space-x-2 px-3 sm:px-4 lg:px-6 py-2 lg:py-3 bg-white/60 backdrop-blur-sm text-gray-700 hover:text-gray-900 hover:bg-white/80 rounded-xl transition-all duration-200 transform hover:scale-105 shadow-sm hover:shadow-md"
                >
                  <ChevronLeft size={20} className="group-hover:-translate-x-1 transition-transform" />
                  <span className="font-medium hidden sm:inline">Previous</span>
                </button>
                
                <div className="flex items-center space-x-3 px-4 lg:px-6 py-2 lg:py-3 bg-gradient-to-r from-blue-600/20 to-purple-600/20 backdrop-blur-sm rounded-xl">
                  <div className="text-sm font-bold text-gray-800">
                    {adFormats.findIndex(ad => ad.id === selectedAdId) + 1}
                  </div>
                  <div className="w-1 h-4 bg-gray-400 rounded-full"></div>
                  <div className="text-sm text-gray-600">
                    of {adFormats.length}
                  </div>
                </div>
                
                <button 
                  onClick={nextAd}
                  className="group flex items-center space-x-2 px-3 sm:px-4 lg:px-6 py-2 lg:py-3 bg-white/60 backdrop-blur-sm text-gray-700 hover:text-gray-900 hover:bg-white/80 rounded-xl transition-all duration-200 transform hover:scale-105 shadow-sm hover:shadow-md"
                >
                  <span className="font-medium hidden sm:inline">Next</span>
                  <ChevronRight size={20} className="group-hover:translate-x-1 transition-transform" />
                </button>
              </div>

              {/* Preview Container */}
              <div className="flex items-center justify-center overflow-hidden">
                <div className={`transition-all duration-500 ${showPreview ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
                  {viewMode === 'mobile' ? (
                    // Mobile Preview
                    <div className="transform hover:scale-105 transition-transform duration-300">
                      <div className="bg-gradient-to-b from-gray-900 to-gray-800 rounded-[2rem] lg:rounded-[3rem] p-2 lg:p-3 shadow-2xl">
                        <div className="bg-black rounded-[1.5rem] lg:rounded-[2.5rem] overflow-hidden w-[280px] sm:w-[300px] h-[600px] sm:h-[650px]">
                          {/* Notch */}
                          <div className="h-6 lg:h-8 bg-black relative">
                            <div className="absolute top-1 lg:top-2 left-1/2 transform -translate-x-1/2 w-20 sm:w-24 lg:w-32 h-3 lg:h-4 bg-gray-900 rounded-full"></div>
                          </div>
                          
                          {/* Status Bar */}
                          <div className="bg-white px-4 lg:px-6 py-1 lg:py-2 flex justify-between items-center text-xs lg:text-sm font-medium">
                            <span>10:59 AM</span>
                            <div className="flex items-center space-x-2">
                              <span className="text-xs">5G</span>
                              <div className="flex space-x-1">
                                {[1,2,3,4].map(i => (
                                  <div key={i} className={`w-1 h-2 lg:h-3 rounded-full ${i <= 3 ? 'bg-black' : 'bg-gray-300'}`}></div>
                                ))}
                              </div>
                              <div className="w-5 lg:w-6 h-2 lg:h-3 border border-black rounded-sm relative">
                                <div className="w-3 lg:w-4 h-1 lg:h-1.5 bg-green-500 rounded-sm m-0.5"></div>
                              </div>
                            </div>
                          </div>
                          
                          {/* App Content */}
                          <div className="bg-gradient-to-b from-blue-50 to-white h-full p-3 sm:p-4 lg:p-6 flex flex-col">
                            <div className="text-center mb-4 lg:mb-6">
                              <div className="text-lg lg:text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                                BidBox.ai
                              </div>
                              <p className="text-gray-500 text-xs lg:text-sm">Ad Preview Platform</p>
                            </div>
                            
                            <div className="flex-1 flex items-center justify-center">
                              <div className="bg-white rounded-xl lg:rounded-2xl p-2 sm:p-3 lg:p-4 shadow-lg">
                                <div className="scale-75 sm:scale-100 origin-center">
                                  <AdContent />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    // Desktop Preview
                    <div className="transform hover:scale-105 transition-transform duration-300 w-full max-w-[900px] lg:max-w-[1000px]">
                      <div className="bg-white/80 backdrop-blur-xl rounded-2xl lg:rounded-3xl shadow-2xl overflow-hidden w-full h-[500px] sm:h-[600px]">
                        {/* Browser Header */}
                        <div className="bg-gray-100/80 backdrop-blur-sm px-4 lg:px-6 py-3 lg:py-4 border-b border-gray-200/50">
                          <div className="flex items-center space-x-3 lg:space-x-4">
                            <div className="flex space-x-2">
                              <div className="w-2 lg:w-3 h-2 lg:h-3 bg-red-500 rounded-full"></div>
                              <div className="w-2 lg:w-3 h-2 lg:h-3 bg-yellow-500 rounded-full"></div>
                              <div className="w-2 lg:w-3 h-2 lg:h-3 bg-green-500 rounded-full"></div>
                            </div>
                            <div className="flex-1 bg-white/60 rounded-lg px-3 lg:px-4 py-1 lg:py-2 text-xs lg:text-sm text-gray-600 truncate">
                              https://bidbox.ai/preview/{currentAd.creativeId}
                            </div>
                          </div>
                        </div>
                        
                        {/* Content */}
                        <div className="p-4 sm:p-6 lg:p-12 h-full bg-gradient-to-br from-gray-50/50 to-blue-50/30 flex items-center justify-center">
                          <div className="text-center">
                            <div className="mb-4 sm:mb-6 lg:mb-8">
                              <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent mb-2">
                                Ad Creative Preview
                              </h2>
                              <p className="text-gray-500 text-sm lg:text-base">
                                {currentAd.name} • {currentAd.dimension}
                              </p>
                            </div>
                            
                            <div className="relative">
                              <div className="absolute -inset-4 bg-gradient-to-r from-blue-400/20 to-purple-400/20 rounded-2xl lg:rounded-3xl blur-xl"></div>
                              <div className="relative bg-white/60 backdrop-blur-sm rounded-xl lg:rounded-2xl p-4 lg:p-8 border border-white/20 shadow-xl">
                                <AdContent />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Right Sidebar */}
            <div className="w-80 lg:w-96 bg-white/80 backdrop-blur-xl border-l border-white/20 shadow-xl p-4 lg:p-6 hidden xl:block flex-shrink-0 overflow-y-auto">
              <div className="mb-6 lg:mb-8">
                <h3 className="text-lg lg:text-xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent mb-2">
                  Creative Analytics
                </h3>
                <p className="text-sm text-gray-500">Real-time performance metrics</p>
              </div>
              
              {/* Ad Details Card */}
              <div className="bg-gradient-to-br from-purple-50 to-blue-50 rounded-xl lg:rounded-2xl p-4 lg:p-6 mb-4 lg:mb-6 border border-purple-100">
                <h4 className="font-bold text-purple-800 mb-3 lg:mb-4 flex items-center">
                  <div className="w-2 h-2 bg-purple-600 rounded-full mr-2 animate-pulse"></div>
                  Current Creative
                </h4>
                <div className="space-y-2 lg:space-y-3">
                  <div className="flex justify-between">
                    <span className="text-gray-600 font-medium text-sm">Dimension:</span>
                    <span className="text-gray-800 font-bold text-sm">{currentAd.dimension}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 font-medium text-sm">Type:</span>
                    <span className="text-gray-800 text-sm">Interactive Video</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 font-medium text-sm">Creative ID:</span>
                    <span className="text-gray-800 font-mono text-xs">{currentAd.creativeId}</span>
                  </div>
                </div>
              </div>

              {/* Performance Metrics */}
              <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-6 mb-6 border border-green-100">
                <h4 className="font-bold text-green-800 mb-4">Performance</h4>
                <div className="space-y-4">
                  <div>
                    <div className="flex justify-between mb-1">
                      <span className="text-sm text-gray-600">Engagement Rate</span>
                      <span className="text-sm font-bold text-green-600">94%</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div className="bg-gradient-to-r from-green-500 to-emerald-500 h-2 rounded-full animate-pulse" style={{width: '94%'}}></div>
                    </div>
                  </div>
                  <div>
                    <div className="flex justify-between mb-1">
                      <span className="text-sm text-gray-600">Click-through Rate</span>
                      <span className="text-sm font-bold text-blue-600">3.2%</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div className="bg-gradient-to-r from-blue-500 to-cyan-500 h-2 rounded-full" style={{width: '32%'}}></div>
                    </div>
                  </div>
                  <div>
                    <div className="flex justify-between mb-1">
                      <span className="text-sm text-gray-600">View Completion</span>
                      <span className="text-sm font-bold text-purple-600">87%</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div className="bg-gradient-to-r from-purple-500 to-pink-500 h-2 rounded-full" style={{width: '87%'}}></div>
                    </div>
                  </div>
                </div>
              </div>

              {/* QR Code */}
              <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-6 border border-gray-200/50 text-center">
                <h4 className="font-bold text-gray-800 mb-4">Quick Access</h4>
                <div className="w-32 h-32 mx-auto mb-4 bg-white rounded-xl flex items-center justify-center shadow-sm">
                  <QrCode size={80} className="text-gray-400" />
                </div>
                <p className="text-xs text-gray-500">
                  Scan to view on mobile device
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiptonDetail;